import { CSSProperties } from "react";

function styleImage(
  width: string,
  height: string,
  objectFit: string
): CSSProperties {
  return {
    width: (function () {
      switch (width) {
        case `fill`:
          return "100%";
        case `auto`:
          return "auto";
        default:
          return "auto";
      }
    })(),
    height: (function () {
      switch (height) {
        case `fill`:
          return "100%";
        case `auto`:
          return "auto";
        default:
          return "auto";
      }
    })(),
    minWidth: (function () {
      switch (width) {
        case `fill`:
          return (function () {
            switch (objectFit) {
              case `contain`:
                return "auto";
              case `cover`:
                return "100%";
              case `fill`:
                return "100%";
              case `none`:
                return "auto";
              case `scale_down`:
                return "auto";
              default:
                return null;
            }
          })();
        case `auto`:
          return "auto";
        default:
          return "100%";
      }
    })(),
    minHeight: (function () {
      switch (height) {
        case `fill`:
          return (function () {
            switch (objectFit) {
              case `contain`:
                return "auto";
              case `cover`:
                return "100%";
              case `fill`:
                return "100%";
              case `none`:
                return "auto";
              case `scale_down`:
                return "auto";
              default:
                return null;
            }
          })();
        case `auto`:
          return "auto";
        default:
          return "100%";
      }
    })(),
    maxWidth: (function () {
      switch (width) {
        case `fill`:
          return (function () {
            switch (objectFit) {
              case `contain`:
                return "100%";
              case `cover`:
                return "auto";
              case `fill`:
                return "100%";
              case `none`:
                return "auto";
              case `scale_down`:
                return "100%";
              default:
                return null;
            }
          })();
        case `auto`:
          return "auto";
        default:
          return "auto";
      }
    })(),
    maxHeight: (function () {
      switch (height) {
        case `fill`:
          return (function () {
            switch (objectFit) {
              case `contain`:
                return "100%";
              case `cover`:
                return "auto";
              case `fill`:
                return "100%";
              case `none`:
                return "auto";
              case `scale_down`:
                return "100%";
              default:
                return null;
            }
          })();
        case `auto`:
          return "auto";
        default:
          return "auto";
      }
    })(),
    objectFit: (function () {
      switch (objectFit) {
        case `contain`:
          return `contain`;
        case `cover`:
          return `cover`;
        case `fill`:
          return `fill`;
        case `none`:
          return `none`;
        case `scale_down`:
          return `scale-down`;
        default:
          return `cover`;
      }
    })(),
  };
}

export default styleImage;
